module.exports = __webpack_public_path__ + "img/solar-powered-charging-station.39f4ca81.png";